import api from './api';

const normalizeSignupStatus = (data = {}) => {
  const passwordSignupEnabled =
    data?.password_signup_enabled !== undefined
      ? Boolean(data.password_signup_enabled)
      : Boolean(data?.signup_enabled ?? true);
  const socialSignupEnabled =
    data?.social_signup_enabled !== undefined
      ? Boolean(data.social_signup_enabled)
      : true;
  const adminSignupEnabled =
    data?.admin_signup_enabled !== undefined
      ? Boolean(data.admin_signup_enabled)
      : Boolean(data?.signup_enabled ?? true);
  const driverSignupEnabled =
    data?.driver_signup_enabled !== undefined
      ? Boolean(data.driver_signup_enabled)
      : true;

  const maxAdminUsers = Number.isFinite(Number(data?.max_admin_users))
    ? Number(data.max_admin_users)
    : null;
  const adminUsersCount = Number.isFinite(Number(data?.admin_users_count))
    ? Number(data.admin_users_count)
    : null;

  const computedRemaining =
    maxAdminUsers !== null && adminUsersCount !== null
      ? Math.max(0, maxAdminUsers - adminUsersCount)
      : null;

  return {
    password_signup_enabled: passwordSignupEnabled,
    social_signup_enabled: socialSignupEnabled,
    admin_signup_enabled: adminSignupEnabled,
    driver_signup_enabled: driverSignupEnabled,
    signup_enabled: socialSignupEnabled && (adminSignupEnabled || driverSignupEnabled),
    max_admin_users: maxAdminUsers,
    admin_users_count: adminUsersCount,
    admin_slots_remaining:
      Number.isFinite(Number(data?.admin_slots_remaining))
        ? Number(data.admin_slots_remaining)
        : computedRemaining,
  };
};

const accountService = {
  getSignupStatus: () => api.get('/accounts/signup-status/').then((r) => normalizeSignupStatus(r.data)),
  getDriverOnboarding: () => api.get('/accounts/driver-onboarding/').then((r) => r.data),
  updateDriverOnboarding: (data) => api.patch('/accounts/driver-onboarding/', data).then((r) => r.data),
};

export default accountService;
